<template lang="">
    <div class="modalVue">
        
        <div class="content d-flex flex-wrap">
            <div class="closeModalVue" @click="close()"></div>

            <div class="col-8 r-side h-100 p-0 m-0 d-flex align-items-center align-content-center justify-content-center flex-wrap">

                <div class="row p-0 w-100 position-absolute top-0">
                    <div class="w-100 text-center d-flex align-items-center justify-content-center font-2 we-1 text-2 mt-4">
                        Registrar nuevo usuario en licencia
                    </div>
                </div>

                <div class="row p-0 w-100 mt-4">
                    <div class="col-5 text-end d-flex align-items-center justify-content-end font-1">
                        Nombre
                    </div>
                    <div class="col-7 d-flex justify-content-start">
                        <input v-model="name" class="font-1 inputModal" @change="this.error=false" :class="error ? 'error' : ''" type="text">
                    </div>
                </div>

                <div class="row p-0 w-100 mt-4">
                    <div class="col-5 text-end d-flex align-items-center justify-content-end font-1">
                        Usuario
                    </div>
                    <div class="col-7 d-flex justify-content-start">
                        <input v-model="user" class="font-1 inputModal" @change="this.error=false" :class="error ? 'error' : ''" type="text">
                    </div>
                </div>

                <div class="row p-0 w-100 mt-4">
                    <div class="col-5 text-end d-flex align-items-center justify-content-end font-1">
                        Contraseña
                    </div>
                    <div class="col-7 d-flex justify-content-start">
                        <input v-model="pass1" class="font-1 inputModal" @change="this.error=false" :class="error ? 'error' : ''" type="password">
                    </div>
                </div>

                <div class="row p-0 w-100 mt-4">
                    <div class="col-5 text-end d-flex align-items-center justify-content-end font-1">
                        Repetir contraseña
                    </div>
                    <div class="col-7 d-flex justify-content-start">
                        <input v-model="pass2" class="font-1 inputModal" @change="this.error=false" :class="error ? 'error' : ''" type="password">
                    </div>
                </div>

                <div class="row p-0 w-100 mt-4 ">
                    <div class="col-5 text-end d-flex align-items-center justify-content-end font-1" >
                        Tipo de usuario
                    </div>
                    <div class="col-7 d-flex justify-content-start">
                        <select v-model="type" class="form-select form-select-lg inputModal" aria-label="">
                            <option v-for="type in types" :value="type">{{type}}</option>
                        </select>
                    </div>
                </div>

                <div class="row p-0 w-100 mt-4 ">
                    <div class="col-5 text-end d-flex align-items-center justify-content-end font-1" >
                        Configuración default
                    </div>
                    <div class="col-7 d-flex justify-content-start">
                        <div class="form-check form-switch">
                            <input class="form-check-input checkInputModal" type="checkbox" id="flexSwitchCheckDefault">
                          </div>
                    </div>
                </div>

                
                <div class="row p-0 w-100 mt-4">
                    <div class="col-12 d-flex justify-content-center">
                        <button class="font-1 logButton" @click="checkLoging()">Agregar</button>
                    </div>
                </div>
               
            </div>

            <div class="col-4 l-side h-100 d-flex flex-wrap justify-content-center align-items-center align-content-center pl-4 d-flex position-relative side">
                <span class="side-conf"></span>
                <span class="w-100 mb-5 topLogo d-flex justify-content-center"><img :src="logo" class=""></span>
                <img :src="a6" class="centerLogo">
            </div>

        </div>

    </div>
</template>
<script>
export default {
    name: "newUserModal",
    emits: ["close"],
    methods: {
        close() {
            this.$emit('close')
        }
    },
    data() {
        return {
            logo: require('@/assets/images/logo1.png'),
            a6: require('@/assets/images/a6.png'),
            pass1: "",
            pass2: "",
            user: "",
            name: "",
            type: "admin",
            error: false,
            loged: false,
            types: [
                "admin", "supervisor", "manager", "server", "foodtruck", "delivery"
            ]
        }
    }
}
</script>
<style lang="css" scoped>
.modalVue {
    width: 100vw;
    height: 100vh;
    background-color: var(--backdrop);
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
}

.content {
    position: relative;
    height: 80%;
    width: 70%;
    background-color: var(--c1);
    z-index: 102;
}

.closeModalVue {
    position: absolute;
    width: 50px;
    height: 50px;
    left: 10px;
    top: 0;
    color: var(--c1);
    cursor: pointer;
    z-index: 1003;
    background-color: var(--sexagenary);
    border-radius: 0 0 4px 4px;
}

.closeModalVue:hover {
    transform: scale(1.5);
    color: var(--secondary);
}

.closeModalVue::after {
    position: relative;
    width: 100%;
    height: 100%;
    content: "\2715";
    font-size: 38px;
    font-weight: 100;
    font-family: 'HelveticaNeueThin';
}


.l-side {
    background-color: var(--cuartenary);
    -webkit-transition: width 0.5s ease-in-out;
    -moz-transition: width 0.5s ease-in-out;
    -o-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out;
}

.l-side img {
    object-fit: contain;
    width: 60%;
    max-width: 400px;
}

.r-side {
    background-color: var(--c1);
}

.inputModal {
    width: 50%;
    height: 40px;
    border-radius: 7px;
    padding: 0 10px 0 10px;
}

.checkInputModal {
    height: 20px;
}

.inputModal.error {
    border: 1px solid var(--secondary);
}

.inputModal:not(.error) {
    border: 1px solid var(--sexagenary);
}

.logButton {
    align-items: center;
    background-color: var(--secondary);
    color: var(--c1);
    border: 0 solid #E2E8F0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
    display: inline-flex;
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-weight: 700;
    height: 56px;
    justify-content: center;
    line-height: 24px;
    overflow-wrap: break-word;
    padding: 24px;
    text-decoration: none;
    width: auto;
    border-radius: 8px;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
}

.logButton:focus {
    box-shadow: var(--secondary) 0 0 0 1.5px inset, rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, var(--secondary) 0 -3px 0 inset;
}

.logButton:hover {
    box-shadow: rgba(45, 35, 66, 0.4) 0 4px 8px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, var(--secondary) 0 -3px 0 inset;
    transform: translateY(-2px);
}

.logButton:active {
    box-shadow: var(--secondary) 0 3px 7px inset;
    transform: translateY(2px);
}

.side-conf {
    background-color: var(--secondary);
    opacity: 0.5;
    height: 100%;
    width: 100%;
    display: block;
    position: absolute;
    background: url("data:image/png;base64,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") repeat 0 0,  var(--secondary);
    -webkit-animation: bg-scrolling-reverse 1.92s infinite;
    -moz-animation: bg-scrolling-reverse 1.92s infinite;
    -o-animation: bg-scrolling-reverse 1.92s infinite;
    animation: bg-scrolling-reverse 1.92s infinite;
    -webkit-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
    -o-animation-timing-function: linear;
    animation-timing-function: linear;
}

.side img.centerLogo{
    width: 30%;
    position: absolute;
}

.side .topLogo{
    position: absolute;
    top:5%;
}

.side .topLogo img{
    position: absolute;
    top:5%;
    width: 40%;
}

@-webkit-keyframes bg-scrolling-reverse {
    100% {
        background-position: 150px 150px;
    }
}

@-moz-keyframes bg-scrolling-reverse {
    100% {
        background-position: 150px 150px;
    }
}

@-o-keyframes bg-scrolling-reverse {
    100% {
        background-position: 150px 150px;
    }
}

@keyframes bg-scrolling-reverse {
    100% {
        background-position: 150px 150px;
    }
}
</style>